<template>
  <el-cascader
    :props="props"
    v-model="innerValue"
    :options="options"
    v-bind="$attrs"
    ref="cascafer"
    v-on="$listeners"
    clearable
    class="address-cascader"
    :append-to-body="false"
  />
</template>

<script>
// import { getProvinceSelector } from '@/api/system/province'
import { dataInterface } from '@/api/dataInterfaceApi'
export default {
  name: 'JNPF-Address-Copy',
  props: ["value", "level"],
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    let that = this;
    return {
      options: [],
      props: {
        lazy: true,
        value: 'value',
        label: 'label',
        children: 'children',
        leaf: 'leaf',
        lazyLoad (node, resolve) {
          const { data, level } = node;
          let id = level === 0 ? -1 : data.value
          dataInterface.provincesList(id).then(res => {
            console.log('执行吗##', res)
            const list = res.data.list.map((value, i) => ({
              value: value.id,
              label: value.fullName,
              leaf: level >= that.level ? true : value.isLeaf
            }));
            resolve(list);
          })
        }
      },
      innerValue: this.value,
    }
  },
  methods: {
    getLabelNames () {
      return this.$refs['cascafer'].getCheckedNodes()[0] ? this.$refs['cascafer'].getCheckedNodes()[0].pathLabels.join('') : ''
    }
  },
  created () { },
  watch: {
    innerValue (val) {
      val && this.$emit('change', val)
    },
    value (val) {

      this.innerValue = val
    }
  }
}
</script>
<style lang="scss" scoped>
.address-cascader {
  width: 100%;
}
.el-popper.el-cascader__dropdown {
  z-index: 9999 !important;
}
</style>
